<template>
  <div class="page-container">
    <Filter :params="params" @search="searchData">
      <template #handle>
        <div class="form-col">
          <el-form-item>
            <el-button type="danger" icon="el-icon-plus" @click="addEdgeGateway">{{ $t('eIoT.deviceConfig.addEdgeGateway') }}</el-button>
            <el-button type="danger" icon="el-icon-plus" @click="addRobot">{{ $t('eIoT.deviceConfig.addRobot') }}</el-button>
          </el-form-item>
        </div>
      </template>
    </Filter>
    <Table :tableData="tableDataList" :total="total" @update="updatePage">
      <el-table-column prop="deviceType" :label="$t('eIoT.deviceConfig.type')">
        <template #default="scope">
          <!-- 类型：2-边缘网关，1-机器人 -->
          <span v-if="scope.row.deviceType == 1">
            <i class="iconfont icon-ota-p058jiqiren" style="color: #D80C25;font-size: 24px"></i>
            {{$t('eIoT.deviceConfig.robot')}}
           </span>
          <span v-if="scope.row.deviceType == 2">
            <i class="iconfont icon-ota-cloud-upload-full" style="color: #0D47A1;font-size: 24px"></i>
            {{$t('eIoT.deviceConfig.edgeGateway')}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="deviceCode" :label="$t('eIoT.deviceConfig.deviceCode')"/>
      <el-table-column prop="deviceName" :label="$t('eIoT.deviceConfig.deviceName')"/>
      <el-table-column prop="cloudLinkStatus" :label="$t('eIoT.deviceConfig.connectionStatus')">
        <template #default="scope">
          <!-- 云端连接状态：0-未连接，1-已连接 -->
          <!-- 边端连接状态：0-未连接，1-已连接 -->
            <!-- 类型：0-边缘网关，1-机器人 -->
          <span v-if="scope.row.uploadMethod">
            <i class="iconfont icon-ota-bianduanAPI" :style="`color: ${scope.row.edgeLinkStatus ? '#2E7D32' : '#9E9E9E' };font-size: 24px`"></i>
            <a :style="`color: ${scope.row.edgeLinkStatus ? '#2E7D32' : '#B85C00' }`">{{$t('eIoT.deviceConfig.gateway')}}</a>
          </span>
          <span v-if="!scope.row.uploadMethod">
            <i class="iconfont icon-ota-yunduan" :style="`color: ${scope.row.cloudLinkStatus ? '#2E7D32' : '#9E9E9E' };font-size: 24px`"></i>
            <a :style="`color: ${scope.row.cloudLinkStatus ? '#2E7D32' : '#B85C00' }`">{{$t('eIoT.deviceConfig.cloud')}}</a>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="uploadMethod" :label="$t('eIoT.deviceConfig.uploadMethod')">
        <template #default="scope">
          <!-- 上传方式，0-直联，1-边端 -->
         <el-tag v-if="scope.row.uploadMethod">{{$t('eIoT.deviceConfig.edgeEndpoint')}}</el-tag>
         <el-tag v-else type="success">{{$t('eIoT.deviceConfig.directConnection')}}</el-tag>
        </template>
      </el-table-column>
       <el-table-column prop="bindEdgeCode" :label="$t('eIoT.deviceConfig.associatedEdge')"/>
      <el-table-column prop="uploadMode" :label="$t('eIoT.deviceConfig.uploadMode')">
        <template #default="scope">
          <!-- 上传模式，0-自动，1-手动 -->
          <el-tag v-if="scope.row.uploadMode">{{$t('eIoT.deviceConfig.manual')}}</el-tag>
          <el-tag v-else type="success">{{$t('eIoT.deviceConfig.auto')}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="diskUsePercent" :label="$t('eIoT.deviceConfig.diskStorage')">
        <template #default="scope">
          <el-tag :type="getDiskStorageColor(scope.row.diskUsePercent)">{{scope.row.diskUsePercent ? scope.row.diskUsePercent : $t('eIoT.deviceConfig.noData')}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="fileCount" :label="$t('eIoT.deviceConfig.viewData')">
        <template #default="scope">
          <el-tag style="cursor: pointer;" @click="scope.row.fileCount && fileManagement(scope.row)">{{ scope.row.fileCount ? scope.row.fileCount : 0}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" :label="$t('eIoT.deviceConfig.queryTime')"/>
      <!-- <el-table-column prop="configStatus" :label="$t('eIoT.deviceConfig.configStatus')">
        <template #default="scope">
          <el-tag v-if="scope.row.configStatus" type="success">
            <i class="el-icon-success"></i>
            {{$t('eIoT.deviceConfig.effective')}}
          </el-tag>
          <el-tag v-else type="warning">
            <i class="el-icon-refresh"></i>
            {{$t('eIoT.deviceConfig.pendingEffective')}}
          </el-tag>
        </template>
      </el-table-column> -->
      <el-table-column :label="$t('activity.list.operation')" fixed="right" width="180">
        <template #default="scope">
          <!-- <el-tooltip class="item" effect="dark" :content="$t('eIoT.deviceConfig.uploadFile')">
            <i @click="uploadFile(scope.row)" class="iconfont icon-ota-shangchuan1" :style="`color: ${scope.row.edgeLinkStatus ? '#2E7D32' : '#9E9E9E' };font-size: 18px`"></i>
          </el-tooltip> -->
          <el-tooltip class="item" effect="dark" :content="$t('eIoT.deviceConfig.viewTransferringData')">
            <i @click="viewTransferring(scope.row)" class="iconfont icon-ota-wuxupailie" :style="`color: #9E9E9E; font-size: 18px;cursor: pointer;`"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="$t('eIoT.deviceConfig.viewUploadedData')">
            <i @click="viewUploaded(scope.row)" class="iconfont icon-ota-chucun" :style="`color: #9E9E9E; font-size: 18px;cursor: pointer;`"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="$t('eIoT.deviceConfig.modifyConfig')">
            <i @click="modify(scope.row)" class="iconfont icon-ota-icon_shezhi" :style="`color: #9E9E9E; font-size: 18px;cursor: pointer;`"></i>
          </el-tooltip>
          <el-tooltip v-if="scope.row.deviceType == 2" class="item" effect="dark" :content="$t('eIoT.deviceConfig.viewAssociatedRobots')">
            <i @click="viewRobot(scope.row)" class="iconfont icon-ota-p058jiqiren" :style="`color: #9E9E9E; font-size: 18px;cursor: pointer;`"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </Table>
    <el-dialog :title="edgeGatewayTitle" v-model="edgeGatewayVisible" destroy-on-close :modal="true" :append-to-body="true">
      <el-form ref="edgeGatewayRef" class="dialog-form" :model="form" :rules="formRules" :label-width="curLang == 'zh-CN' ? '150px' : curLang == 'en-US' ? '240px' : '220px'">
        <el-form-item :label="$t('eIoT.deviceConfig.edgeCode')" prop="deviceCode">
          <el-input v-model="form.deviceCode" :placeholder="$t('eIoT.deviceConfig.edgeCode')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('eIoT.deviceConfig.edgeName')" prop="deviceName">
          <el-input v-model="form.deviceName" :placeholder="$t('eIoT.deviceConfig.edgeName')"/>
        </el-form-item>
        <el-form-item :label="$t('eIoT.deviceConfig.ipAddress')" prop="ipAddress">
          <el-input v-model="form.ipAddress" :placeholder="$t('eIoT.deviceConfig.ipAddress')"/>
        </el-form-item>
        <el-form-item :label="$t('eIoT.deviceConfig.uploadMode')" prop="uploadMode">
          <el-select v-model="form.uploadMode" :placeholder="$t('eIoT.deviceConfig.uploadMode')" clearable>
            <el-option :key="0" :label="$t('eIoT.deviceConfig.auto')" :value="0"></el-option>
            <el-option :key="1" :label="$t('eIoT.deviceConfig.manual')" :value="1" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('eIoT.deviceConfig.description')" prop="description">
          <el-input  type="textarea" :autosize="{ minRows: 4 }" v-model="form.description" :placeholder="$t('eIoT.deviceConfig.description')"/>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" size="small" @click="onSubmitGateWay">{{$t('activity.list.confirm')}}</el-button>
      </template>
    </el-dialog>
    <el-dialog :title="robotTitle" v-model="robotVisible" destroy-on-close :modal="true" :append-to-body="true">
      <el-form ref="robotRef" class="dialog-form" :model="form" :rules="formRobotRules" :label-width="curLang == 'zh-CN' ? '150px' : curLang == 'en-US' ? '240px' : '220px'">
        <el-form-item :label="$t('eIoT.deviceConfig.robotCode')" prop="deviceCode">
          <el-select :disabled="form.id !== ''" v-model="form.deviceCode" :placeholder="$t('eIoT.deviceConfig.robotCode')" :remote-method="robotSnQuery" @change="(val)=>onRobotChange(val)" filterable remote clearable>
            <el-option
              v-for="(item) in robotSnList"
              :key="item.robotId"
              :label="item.robotId"
              :value="item.robotId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('eIoT.deviceConfig.robotName')" prop="deviceName">
          <el-input v-model="form.deviceName" :placeholder="$t('eIoT.deviceConfig.robotName')"/>
        </el-form-item>
        <el-form-item :label="$t('eIoT.deviceConfig.uploadMethod')" prop="uploadMethod">
          <el-select v-model="form.uploadMethod" :placeholder="$t('eIoT.deviceConfig.uploadMethod')" clearable @change="(val)=> form.bindEdgeCode = ''">
            <el-option :key="0" :label="$t('eIoT.deviceConfig.directConnection')" :value="0"></el-option>
            <el-option :key="1" :label="$t('eIoT.deviceConfig.edgeEndpoint')" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.uploadMethod == 1" :label="$t('eIoT.deviceConfig.associatedEdge')" prop="bindEdgeCode">
          <el-input v-model="form.bindEdgeCode" :placeholder="$t('eIoT.deviceConfig.associatedEdge')"/>
        </el-form-item>
        <el-form-item :label="$t('eIoT.deviceConfig.uploadMode')" prop="uploadMode">
          <el-select v-model="form.uploadMode" :placeholder="$t('eIoT.deviceConfig.uploadMode')" clearable>
            <el-option :key="0" :label="$t('eIoT.deviceConfig.auto')" :value="0"></el-option>
            <el-option :key="1" :label="$t('eIoT.deviceConfig.manual')" :value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" size="small" @click="onSubmitRobot">{{$t('activity.list.confirm')}}</el-button>
      </template>
    </el-dialog>
    <el-dialog :title="`${$t('eIoT.deviceConfig.edgeAssociatedRobots')} . ${detail?.deviceCode}`" v-model="asociatedRobotsVisible" destroy-on-close :modal="true" :append-to-body="true">
      <el-table
        :data="robotList"
        style="width: 100%">
      <!-- <Table :tableData="tableDataList" :total="total" @update="updatePage"> -->
        <el-table-column prop="deviceCode" :label="$t('eIoT.deviceConfig.robotCode')">
          <template #default="scope">
            <!-- 类型：2-边缘网关，1-机器人 -->
          {{scope.row.deviceType == 1 ? $t('eIoT.deviceConfig.robot') : $t('eIoT.deviceConfig.edgeGateway')}}
          </template>
        </el-table-column>
        <el-table-column prop="deviceName" :label="$t('eIoT.deviceConfig.robotName')"/>
        <el-table-column prop="cloudLinkStatus" :label="$t('eIoT.deviceConfig.connectionStatus')">
          <template #default="scope">
            <!-- 云端连接状态：0-未连接，1-已连接 -->
            <!-- 边端连接状态：0-未连接，1-已连接 -->
            <span v-if="scope.row.uploadMethod">
              <i class="iconfont icon-ota-bianduanAPI" :style="`color: ${scope.row.edgeLinkStatus ? '#2E7D32' : '#9E9E9E' };font-size: 24px`"></i>
              <a :style="`color: ${scope.row.edgeLinkStatus ? '#2E7D32' : '#B85C00' }`">{{$t('eIoT.deviceConfig.gateway')}}</a>
            </span>
            <span v-if="!scope.row.uploadMethod">
              <i class="iconfont icon-ota-yunduan" :style="`color: ${scope.row.cloudLinkStatus ? '#2E7D32' : '#9E9E9E' };font-size: 24px`"></i>
              <a :style="`color: ${scope.row.cloudLinkStatus ? '#2E7D32' : '#B85C00' }`">{{$t('eIoT.deviceConfig.cloud')}}</a>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog :title="`${$t('eIoT.deviceConfig.fileManagement')} . ${detail?.deviceCode}`" v-model="fileVisible" destroy-on-close :modal="true" :append-to-body="true">
      <el-table :data="fileList" style="width: 100%">
        <el-table-column prop="fileName" :label="$t('eIoT.deviceConfig.fileName')">
        </el-table-column>
        <el-table-column prop="fileSize" :label="$t('eIoT.transmit.size')">
        <template #default="scope">
          {{ `${scope.row.fileSize} MB` }}
        </template>
      </el-table-column>
        <el-table-column prop="updateTime" :label="$t('eIoT.deviceConfig.modificationTime')"/>
      </el-table>
      <!-- <template #footer>
        <el-button type="primary" size="small" @click="onSubmitRobot">{{$t('activity.list.confirm')}}</el-button>
      </template> -->
    </el-dialog>
  </div>
</template>

<script>
import { request } from '@/utils/request';
import { common } from '@/common/mixin';
import Table from "@/components/table/index";
import Filter from "@/components/table/filter";
import { ElMessage } from "element-plus";
import { computed } from "vue";
import { useStore } from "vuex";
import { reqFileList, reqBindRobotList } from '@/api/resource';

// import { useI18n } from 'vue-i18n'
// const { t } = useI18n()
export default {
  components: {
    Table,
    Filter
  },
  mixins: [common],
  data() {
    const store = useStore()
    return {
      edgeGatewayVisible: false,
      robotVisible: false,
      asociatedRobotsVisible: false,
      fileVisible: false,
      edgeGatewayRef: null,
      robotRef: null,
      form: {
        deviceCode: '',
        deviceName: '',
        description: '',
        ipAddress: '',
        uploadMode: null,
        id: ''
      },
      formRules: {
        deviceCode: {
          required: true,
          message: this.$t('eIoT.deviceConfig.edgeCode'),
          trigger: 'blur',
        },
        deviceName: {
          required: true,
          message: this.$t('eIoT.deviceConfig.edgeName'),
          trigger: 'blur',
        },
        uploadMode: {
          required: true,
          message: this.$t('eIoT.deviceConfig.uploadMode'),
          trigger: 'blur'
        }
      },
      formRobotRules: {
        deviceCode: {
          required: true,
          message: this.$t('eIoT.deviceConfig.robotCode'),
          trigger: 'blur',
        },
        uploadMode: {
          required: true,
          message: this.$t('eIoT.deviceConfig.uploadMode'),
          trigger: 'blur'
        },
        uploadMethod: {
          required: true,
          message: this.$t('eIoT.deviceConfig.uploadMethod'),
          trigger: 'blur',
        }
      },
      params: [
        {
          type: "Select",
          key: "deviceType",
          value: '',
          label: this.$t('eIoT.deviceConfig.type'),
          options: {
            data: [{ name: this.$t('eIoT.deviceConfig.edgeGateway'), value: 2 }, { name: this.$t('eIoT.deviceConfig.robot'), value: 1 }],
            label: "name",
            value: "value"
          }
        },
        {
          key: 'deviceCode',
          value: '',
          label: this.$t('eIoT.deviceConfig.deviceCode')
        },
        {
          key: 'deviceName',
          value: '',
          label: this.$t('eIoT.deviceConfig.deviceName')
        },
        {
          type: "Select",
          key: "linkStatus",
          value: '',
          label: this.$t('eIoT.deviceConfig.connectionStatus'),
          options: {
            data: [{ name: this.$t('eIoT.deviceConfig.online'), value: 1 }, { name: this.$t('eIoT.deviceConfig.offline'), value: 0 }],
            label: "name",
            value: "value"
          }
        },
        {
          type: "Select",
          key: "uploadMethod",
          value: '',
          label: this.$t('eIoT.deviceConfig.uploadMethod'),
          options: {
            data: [{ name: this.$t('eIoT.deviceConfig.directConnection'), value: 0 }, { name: this.$t('eIoT.deviceConfig.edgeEndpoint'), value: 1 }],
            label: "name",
            value: "value"
          }
        },
        {
          type: "Select",
          key: "uploadMode",
          value: '',
          label: this.$t('eIoT.deviceConfig.uploadMode'),
          options: {
            data: [{ name: this.$t('eIoT.deviceConfig.auto'), value: 0 }, { name: this.$t('eIoT.deviceConfig.manual'), value: 1 }],
            label: "name",
            value: "value"
          }
        },
        {
          type: "Date",
          key: "timeRange",
          value: [],
          label: this.$t('eIoT.deviceConfig.queryTime'),
          options: {
            "type": "datetimerange",
            "format": "YYYY-MM-DD HH:mm:ss",
            "value-format": "YYYY-MM-DD HH:mm:ss",
            "range-separator": this.$t('activity.detail.to'),
            "start-placeholder": this.$t('activity.list.startDate'),
            "end-placeholder": this.$t('activity.list.endDate'),
            "default-time": [new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 1, 1, 23, 59, 59)]
          }
        },
      ],
      query: {},
      page: 1,
      size: 10,
      total: 0,
      tableDataList: [],
      provinceList: [],
      cityList: [],
      areaList: [],
      robotStatusList: [], // 机器人状态下拉列表
      industryList: [], // 行业下拉列表
      curLang: computed(() => store.state.lang),
      authList: JSON.parse(window.localStorage.getItem('authList')),
      detail: {},
      robotSnList: [],
      robotTitle: this.$t('eIoT.deviceConfig.addRobot'),
      edgeGatewayTitle: this.$t('eIoT.deviceConfig.addEdgeGateway'),
      fileList: [],
      robotList: []
    }
  },
  watch: {
    "query.province": function(value, old) {
      if (value && (value!==old)) {
        console.log('province', value)
        request('getArea', {
          parentId: Number(value)
        })
        .then((data) => {
          this.cityList = data;
        })
      }
    },
    "query.city": function(value, old) {
      if (value && (value!==old)) {
        request('getArea', {
          parentId: Number(value)
        })
        .then((data) => {
          this.areaList = data;
        })
      }
    }
  },
  created() {
    window.$this = this;
    this.getData()
    // this.getDataMap()
  },
  mounted () {
    // this.tableDataList = robotList({}).then(data => {
    //   this.tableDataList = data
    // })
    // this.$store.dispatch('status/robot', {})
    // .then(data => {
    //   console.log(data)
    // })
    // robotList({}).then(data => {
    //   this.tableDataList = data
    // })
  },
  methods: {
    getData() {
      request('deviceList', {
        ...this.query,
        page: this.page,
        size: this.size
      })
      .then((data) => {
        this.tableDataList = data.records;
        this.total = data.total;
        // this.tableDataList = [].concat(data.records);
      })
      .catch((error) => {
        console.log(error);
      })
    },
    getDataMap() {
      try {
        request('getArea', {
          parentId: 1
        })
        .then((data) => {
          this.provinceList = data;
        })
        request('getRobotStatusMap')
        .then((data) => {
          this.robotStatusList = data;
        })
        request('getIndustryList')
        .then((data) => {
          this.industryList = data;
        })
      } catch (error) {
        console.log(error)
      }
    },
    searchData(data) {
      this.query = data
      this.getData()
    },
    updatePage(page, size) {
      this.page = page || 1
      this.size = size || 10
      this.getData()
    },
    addEdgeGateway() {
      for (let key of Object.keys(this.form)) {
        this.form[key] = ''
      }
      this.edgeGatewayVisible = true
    },
    addRobot() {
      for (let key of Object.keys(this.form)) {
        this.form[key] = ''
      }
      this.robotVisible = true
    },
    editRobot(data) {
      console.log(data)
      for (let key of Object.keys(this.form)) {
        if (data[key]) {
          this.form[key] = data[key]
        } else {
          this.form[key] = ''
        }
      }
      this.form.id = data.id
      this.dialogFormVisible = true
      return
    },
    uploadFile(row) {
      console.log(row)
    },
    viewTransferring(row) {
      this.$router.push(`/eIoT/transmitting?deviceType=${row.deviceType}&&deviceCode=${row.deviceCode}`)
    },
    viewUploaded(row) {
      this.$router.push(`/eIoT/transmitted?deviceType=${row.deviceType}&&deviceCode=${row.deviceCode}`)
    },
    modify(row) {
      this.detail = {}
      this.form = {}
      Object.keys(row).forEach(key => {
        this.detail[key] = row[key]
        this.form[key] = row[key]
      })
      if(row.deviceType == 1){
        this.robotVisible = true
        this.robotTitle = this.$t('eIoT.deviceConfig.modifyRobotConfig')
      }
      if(row.deviceType == 2){
        this.edgeGatewayVisible = true
        this.edgeGatewayTitle = this.$t('eIoT.deviceConfig.modifyEdgeGatewayConfig')
      }
      
    },
    async viewRobot(row) {
      this.detail.deviceCode = row.deviceCode
      this.asociatedRobotsVisible = true
      try {
        const res = await reqBindRobotList({edgeCode: row.deviceCode})
        this.robotList = res
      } catch (error) {
        console.error(error)
      }
    },
    async fileManagement(row) {
      this.detail.deviceCode = row.deviceCode
      try {
        const res = await reqFileList({uuid: row.uuid})
        this.fileList = res
      } catch (error) {
        console.error(error)
      }
      // import { reqFileList, reqBindRobotList } from '@/api/resource';
      this.fileVisible = true
    },
    async onSubmitGateWay() {
      try {
        this.$refs.edgeGatewayRef && await this.$refs.edgeGatewayRef.validate()
        await request('edgeGateWay', this.form)
        ElMessage({
          showClose: true,
          type: "success",
          message: this.$t('activity.list.submitSuccess')
        })
        this.edgeGatewayVisible = false
        this.getData()
      } catch (error) {
        console.error(error)
      }
    },
    async onSubmitRobot() {
      try {
        this.$refs.robotRef && await this.$refs.robotRef.validate()
        await request('embodyRobot', this.form)
        ElMessage({
          showClose: true,
          type: "success",
          message: this.$t('activity.list.submitSuccess')
        })
        this.robotVisible = false
        this.getData()
      } catch (error) {
        console.error(error)
      }
    },
    onCancel () {
      this.dialogFormVisible = false
    },
    dateChange() {
      console.log('dateChange: ', this.dateRange)
    },
    async robotSnQuery (name) {
      try {
        this.robotSnList = []
        const res = await request('getCollectRobot', {robotId: name})
        this.robotSnList = (res.records || []).slice(0, 20)
      } catch (error) {
        console.error(error)
      }
    },
    onRobotChange (val) {
      const currtRobot = this.robotSnList.filter(item=> item.robotId == val)[0]
      this.form.deviceName = currtRobot.robotName
    },
    getDiskStorageColor(percentage) {
      if (parseFloat(percentage) < 70) {
        return 'success';
      } else if (parseFloat(percentage) >= 70 && parseFloat(percentage) < 85) {
        return 'warning';
      } else if (parseFloat(percentage) >= 85 && parseFloat(percentage) <= 100) {
        return 'danger';
      } else {
        return 'info'; // Handle percentages > 100
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
</style>
